import { useTheme } from "../../context/ThemeContext";

export default function FilterSelect({
  value,
  onChange,
  options,
}) {

  const { isDark } = useTheme();

  return (
    <select
      value={value}
      onChange={onChange}
      className={`
        px-4
        py-3
        rounded-xl
        border
        ${
          isDark
            ? `
              bg-black
              border-white/10
            `
            : `
              bg-white
              border-gray-300
            `
        }
      `}
    >
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}